import ExamImageComponent from './ExamImageComponent';

function ExamImageField(props) {
	const { value } = props.field;
	if (value) return <ExamImageComponent {...props} />;
	return <></>;
}
export default ExamImageField;
